import React from 'react';
import { NavLink } from 'react-router-dom';
import Footer from '../components/Footer';
import Header from '../components/Header';
import axios from "axios";
import { useEffect, useState } from "react";
import Loader from "../components/Loader";
import HomeSlider from '../components/HomeSlider';
import * as Constants from '../components/Constants';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


const Home = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${Constants.LARAVEL_API_URL}/categories`).then(res => {
        if (res.data.status === 200) {
          setLoading(false);
          setCategories(res.data.categories);
        }
      }).catch();
  }, []);

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 2,
    initialSlide: 0,
    autoplay:true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <>
    <main>
      <Header />
      <section>   
        <div className="slider">     
          {loading ? <Loader width={400} height={400} /> : <HomeSlider />}
        </div>
      </section>
      <section className="homeBestWrap">
        <div className="container">
          <div className="homeBestCategories">
            {loading ? <Loader width={200} height={200} /> : categories.slice(0, -1).map((category)=>(
              <div className="homeBestCatItem" key={category.id}>
                <h3>{category.name}</h3>
                <img src={`${Constants.LARAVEL_URL}/assets/images/categories/${category.image}`} alt={category.name} />
                <NavLink to={`/catalog/${category.slug}`} className="homeBestBtn">
                  Перейти в раздел
                </NavLink>
              </div>
            ))}
          </div>
          <div className="homeBestAboutNumbers">
            <div className="homeBestAbout">
              <h2 className="homeH2">О нас</h2>
              <div className="homeBestAboutContent">
                <p>
                Компания ТОО «Оптические Технологии» — поставщик и интегратор технологических решений в области телекоммуникаций, энергетики и промышленной автоматизации. Компания реализует проекты для заказчиков, помогая предприятиям различных отраслей в Казахстане и странах Центральной Азии повысить операционную эффективность. Благодаря большому опыту и постоянному совершенствованию у компании сформировались отличительные преимущества, которые позволило стать официальным дистрибьютором ведущих мировых производителей.<br/><br/>
                ТОО «Оптические Технологии» сотрудничает с такими мировыми компаниями как Anritsu Corporation, Sumitomo Electric, Yokogawa Electric Corporation, Aaronia AG, Fluke, Rohde&Schwarz, Triathlon Batterien GmbH и тд.
                </p>
                <NavLink to="/about">
                  <div className="homeBestBtn">
                    Перейти в раздел
                  </div>
                </NavLink>
              </div>
            </div>
            <div className="homeBestNumbers">
              <h2 className="homeH2">преимущества в цифрах</h2>
              <div className="homeBestNumberItemWrap">              
                <div className="homeBestNumberItem">
                  <div className="homeBestNumberNum">
                    11
                  </div>
                  <p><strong>11 лет</strong> опыта в оптических <br/> технологиях и решениях</p>
                </div>
                <div className="homeBestNumberItem">
                  <div className="homeBestNumberNum">
                  1000+
                  </div>
                  <p>Проданно свыше <strong>1000</strong><br/> оборудования</p>
                </div>
                <div className="homeBestNumberItem">
                  <div className="homeBestNumberNum">
                  30+
                  </div>
                  <p>Более <strong>30</strong> постоянных<br/>клиентов и партнеров</p>
                </div>
                <div className="homeBestNumberItem">
                  <div className="homeBestNumberNum">
                  100+
                  </div>
                  <p>Более <strong>100</strong> Реализованных<br/> проектов</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="container">
        <div className="specialService">
          <div className="special">
            <NavLink to="/offers">
              <img
                src="uploads/images/special1.jpg"
                alt="Cпециальные предложения"
                width="640"
                height="244"
              />
            <div className="specialText">
              <p>Cпециальные предложения</p>
            </div>
            </NavLink>
          </div>
          <div className="special">
            <NavLink to="/services">
              <img
                src="uploads/images/special2.jpg"
                alt="Сервис и услуги"
                width="640"
                height="244"
              />
            <div className="specialText">
              <p>Сервис и услуги</p>
            </div>            
            </NavLink>
          </div>
        </div>
      </section>
      <section className="container">
        <div className="solutionsWrap">
          <h2 className="homeH2">Решения</h2>
        </div>
        <div className="solutionContent">
            <div className="solutionItem">
              <img
                src="uploads/solutions/1.jpg"
                alt="Сервис и услуги"
                width="293"
                height="189"
                className="solutionItemImg"
              />
              <p>Телекоммуникации</p>
            </div>
            <div className="solutionItem">
              <img
                src="uploads/solutions/2.jpg"
                alt="Сервис и услуги"
                width="293"
                height="189"
                className="solutionItemImg"
              />
              <p>Нефть и газ</p>
            </div>
            <div className="solutionItem">
              <img
                src="uploads/solutions/3.jpg"
                alt="Сервис и услуги"
                width="293"
                height="189"
                className="solutionItemImg"
              />
              <p>Диагностика АКБ</p>
            </div>
            <div className="solutionItem">
              <img
                src="uploads/solutions/4.jpg"
                alt="Сервис и услуги"
                width="293"
                height="189"
                className="solutionItemImg"
              />
              <p>Прочие решения</p>
            </div>
        </div>
      </section>
      <section className="container">
        <div className="articlesWrap">
          <h2 className="homeH2">Новости компании</h2>
        </div>
        <div className="articlesContent">
          <div className="articlesItem">
              <div className="articlesItemImgWrap">
                <img
                  src="uploads/articles/1.jpg"
                  alt="Сервис и услуги"
                  width="380"
                  height="150"
                  className="articlesItemImg"
                />
              </div>
              <div className="articlesItemContent">
                <h4>Волоконно-оптическая система мониторинга ЛЭП</h4>
                <p>
                  Волоконно-оптическая система геотехнического мониторинга (ВОС ГТМ) состоит из 3-х основных компонентов: анализатор, протяженный (непрерывный)
                </p>
              </div>
          </div>
          <div className="articlesItem">
            <div className="articlesItemImgWrap">
                <img
                  src="uploads/articles/2.jpg"
                  alt="Сервис и услуги"
                  width="380"
                  height="150"
                  className="articlesItemImg"
                />
              </div>
              <div className="articlesItemContent">
                <h4>Дистанционный мониторинг взрывоопасных концентраций метана</h4>
                <p>
                  Согласно Федеральным нормам и правилам в области промышленной безопасности «Правила безопасности для опасных производственных объектов магистральных .трубопроводов»
                </p>
              </div>              
          </div>
          <div className="articlesItem">
              <div className="articlesItemImgWrap">
                <img
                  src="uploads/articles/3.jpg"
                  alt="Сервис и услуги"
                  width="380"
                  height="150"
                  className="articlesItemImg"
                />
              </div>
              <div className="articlesItemContent">
                <h4>5G New Radio (5G NR): особенности проектирования новых решений.</h4>
                <p>
                  После того, как был принят первый стандарт 5G New Radio (5G NR), фокус внимания инженеров-разработчиков новых продуктов в области беспроводной связи прогнозируемо сместился от этапа исследования
                </p>
              </div>
          </div>
        </div>
      </section>
      <section>
        <div className="partnersWrap">
          <h2 className="homeH2">Наши партнеры</h2>
        </div>
        <div className="slider-container container">
        <Slider {...settings}>
            <img
              src={`${Constants.LARAVEL_URL}/assets/images/partners/1.png`}
              alt="Наши партнеры"
              className="articlesItemImg"
            />
            <img
              src={`${Constants.LARAVEL_URL}/assets/images/partners/2.png`}
              alt="Наши партнеры"
              className="articlesItemImg"
            />
            <img
              src={`${Constants.LARAVEL_URL}/assets/images/partners/3.png`}
              alt="Наши партнеры"
              className="articlesItemImg"
            />
            <img
              src={`${Constants.LARAVEL_URL}/assets/images/partners/4.png`}
              alt="Наши партнеры"
              className="articlesItemImg"
            />
            <img
              src={`${Constants.LARAVEL_URL}/assets/images/partners/5.png`}
              alt="Наши партнеры"
              className="articlesItemImg"
            />
            <img
              src={`${Constants.LARAVEL_URL}/assets/images/partners/6.png`}
              alt="Наши партнеры"
              className="articlesItemImg"
            />
            <img
              src={`${Constants.LARAVEL_URL}/assets/images/partners/7.png`}
              alt="Наши партнеры"
              className="articlesItemImg"
            />
            </Slider>
        </div>
      </section>
      </main>
      <Footer />
    </>
  )
}

export default Home


